import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { confirmAlert } from "react-confirm-alert"
import Loader from "react-loader-spinner"
import propTypes from "prop-types"
import "./styles.scss"

import {
  fetchSupportRequests,
  saveSupportRequest,
  toggleEndorsement,
  archiveSuggestions
} from "../../../../services/plans"
import { validateForm } from "../../../../services/validation"
import configs from "../../../../configs"

import Messages from "../Messages"
import Form, { TextArea, Input } from "../../../../components/Form"
import Button from "../../../../components/Button"

class RequestSupport extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedGuardians: [],
      allGuardiansIsChecked: false,
      formParticipant: {
        helpMessage: {
          name: "helpMessage",
          type: "textarea",
          value: "",
          required: true
        }
      },
      formGuardian: {
        suggestionTitle: {
          name: "suggestionTitle",
          type: "text",
          value: "",
          required: true
        },
        suggestionProblem: {
          name: "suggestionProblem",
          type: "text",
          value: "",
          required: true
        },
        suggestionMessage: {
          name: "suggestionMessage",
          type: "textarea",
          value: "",
          required: true
        }
      },
      isSubmitted: false,
      errorMessage: "",
      supportRequestsFilterValue: "suggestion"
    }
  }

  componentDidMount() {
    this.handlFetchSupportRequests()
  }

  componentDidUpdate(prevProps) {
    const { planSection } = this.props

    if (prevProps.planSection !== planSection) {
      this.handlFetchSupportRequests()
    }
  }

  handlFetchSupportRequests = () => {
    const {
      onFetchSupportRequests,
      store: { user, planId },
      location,
      planSection
    } = this.props

    const { supportRequestsFilterValue } = this.state

    if (user.list_role.includes(configs.roles.Guardian) && location.state) {
      if (location.state.planId) {
        onFetchSupportRequests(
          user.token,
          planSection,
          location.state.planId,
          supportRequestsFilterValue
        )
      }
    } else {
      onFetchSupportRequests(
        user.token,
        planSection,
        planId,
        supportRequestsFilterValue
      )
    }
  }

  allGuardiansToggle = checked => {
    this.setState({
      allGuardiansIsChecked: checked,
      selectedGuardians: checked ? ["all"] : []
    })
  }

  onToggleMembers = id => {
    const { selectedGuardians } = this.state
    let existing

    const results = selectedGuardians.filter(item => {
      if (item === "all") {
        existing = false
        return false
      }
      if (item.id === id) {
        existing = true
        return false
      }
      existing = false
      return true
    })

    if (!existing) {
      results.push({ id })
    }

    this.setState({ selectedGuardians: results, allGuardiansIsChecked: false })
  }

  onChange = (name, field, value) => {
    const {
      store: { user }
    } = this.props
    const { formParticipant, formGuardian } = this.state

    let form
    let formName

    if (user.list_role.includes(configs.roles.Participant)) {
      formName = "formParticipant"
      form = formParticipant
    } else if (user.list_role.includes(configs.roles.Guardian)) {
      formName = "formGuardian"
      form = formGuardian
    }

    this.setState({
      [formName]: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  getFilteredSupportRequests = value => {
    this.setState(
      {
        supportRequestsFilterValue: value
      },
      () => {
        this.handlFetchSupportRequests()
      }
    )
  }

  handlSaveSupportRequest = () => {
    const {
      store: { user },
      guardians,
      planSection,
      planSubsection,
      onSaveSupportRequest
    } = this.props
    const { selectedGuardians, formParticipant } = this.state
    const filteredGuardians = guardians.filter(
      ({ relationship }) => !relationship.status.includes("pending")
    )

    let newSelectedGuardians

    if (selectedGuardians[0] === "all") {
      newSelectedGuardians = filteredGuardians.map(guardian => {
        if (guardian.relationship.status.includes("pending")) {
          return false
        }
        return { id: guardian.id }
      })
    } else {
      newSelectedGuardians = selectedGuardians
    }

    const res = validateForm(formParticipant)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      onSaveSupportRequest(
        user.token,
        {
          guardians: newSelectedGuardians,
          content: formParticipant.helpMessage.value,
          planSection,
          planSubsection
        },
        "participant"
      ).then(
        () => {
          this.handlFetchSupportRequests()

          this.setState({ errorMessage: "" })
        },
        e => {
          this.setState({ errorMessage: e.error })
        }
      )
    } else {
      this.setState({
        isSubmitted: true,
        formParticipant: {
          ...formParticipant,
          ...res
        }
      })
    }
  }

  handlSaveSupportSuggestion = () => {
    const {
      store: { user },
      planSection,
      planSubsection,
      onSaveSupportRequest,
      location
    } = this.props
    const { formGuardian } = this.state

    const res = validateForm(formGuardian)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      confirmAlert({
        title: "Confirm your suggestion",
        message: "Once you submit your suggestion it cannot be edited.",
        buttons: [
          {
            label: "Confirm",
            onClick: () => {
              onSaveSupportRequest(
                user.token,
                {
                  plan: { id: location.state.planId },
                  title: formGuardian.suggestionTitle.value,
                  problem: formGuardian.suggestionProblem.value,
                  content: formGuardian.suggestionMessage.value,
                  planSection,
                  planSubsection
                },
                "guardian"
              ).then(
                () => {
                  this.handlFetchSupportRequests()
                },
                () => {}
              )
            }
          },
          {
            label: "Go back"
          }
        ]
      })
    } else {
      this.setState({
        isSubmitted: true,
        formGuardian: {
          ...formGuardian,
          ...res
        }
      })
    }
  }

  handleToggleEndorsement = suggestionId => {
    const {
      store: { user },
      onToggleEndorsement
    } = this.props

    onToggleEndorsement(user.token, suggestionId).then(() => {
      this.handlFetchSupportRequests()
    })
  }

  getSupportRequestMessages = () => {
    const {
      store: { supportRequests },
      planSection,
      planSubsection
    } = this.props

    const supportRequestMessages = []
    let item

    if (supportRequests) {
      if (
        Object.keys(supportRequests).length !== 0 &&
        supportRequests.constructor === Object
      ) {
        if (planSection === "AM") {
          item = supportRequests.plan_section_entities.data[planSubsection - 1]
        } else {
          supportRequests.plan_section_entities.data.map(dataItem => {
            if (dataItem.id === planSubsection) {
              item = dataItem
            }

            return null
          })
        }

        if (item) {
          if (item.help_request) {
            supportRequestMessages.push({
              type: "help-request",
              planSection,
              id: item.help_request.id,
              iconDesc: "handshake",
              createdAt: item.help_request.created_at,
              title: `${item.help_request.participant.first_name} requested support`,
              subtitle: `Section: ${configs.plan_section[planSection]}`,
              content: item.help_request.content
            })
          }

          if (item.suggestions) {
            item.suggestions.map(suggestion => {
              supportRequestMessages.push({
                type: "suggestion",
                planSection,
                endorsements: suggestion.endorsements,
                id: suggestion.id,
                createdAt: suggestion.created_at,
                title: `${configs.plan_section[planSection]} ${suggestion.title}`,
                subtitle: `${suggestion.guardian.first_name} \u00A0 ${suggestion.problem}`,
                firstName: suggestion.guardian.first_name,
                content: suggestion.content
              })

              return null
            })
          }
        }
      }
    }

    return supportRequestMessages
  }

  handleArchiveSuggestions = (id, planSection) => {
    const {
      store: { user },
      onArchiveSuggestions
    } = this.props

    if (id) {
      onArchiveSuggestions(user.token, {
        id,
        planSection
      }).then(() => {
        this.handlFetchSupportRequests()
      })
    }
  }

  render() {
    const {
      className,
      isHidden,
      guardians,
      onToggle,
      store: { supportRequestsLoading, user }
    } = this.props
    const {
      allGuardiansIsChecked,
      selectedGuardians,
      formParticipant,
      formGuardian,
      isSubmitted,
      errorMessage,
      supportRequestsFilterValue
    } = this.state

    const filteredGuardians = guardians.filter(
      ({ relationship }) => !relationship.status.includes("pending")
    )

    const filterOptions = [
      {
        value: "suggestion",
        label: "Suggestions"
      },
      {
        value: "endorsement",
        label: "Most endorsed"
      },
      {
        value: "requests",
        label: "Requests"
      }
    ]

    const participant = user.list_role.includes(configs.roles.Participant)

    const guardian = user.list_role.includes(configs.roles.Guardian)

    return (
      <div className={`request-support ${className}`}>
        <div className="request-support_btn-wrap">
          <button
            type="button"
            onClick={onToggle}
            className="request-support_btn"
          >
            {isHidden ? "Show request support" : "Hide request support"}
          </button>
        </div>

        {!isHidden && (
          <>
            {participant && (
              <>
                <div className="request-support_title">Request support</div>
                <div className="request-support_description">
                  Request support from your support team, they will make
                  suggestions to help you improve your plan.
                </div>

                <div className="request-support_section">
                  <div className="request-support_section_title">
                    Support message
                  </div>

                  <Form>
                    {!!filteredGuardians.length && (
                      <div className="request-support_section_item">
                        <div className="request-support_section_label">
                          Request support from your team who will make
                          suggestions to improve your pre-plan.
                        </div>

                        {errorMessage && (
                          <div className="form_message form_message--global">
                            {errorMessage}
                          </div>
                        )}

                        <div className="request-support_guardians">
                          <div className="form_checkbox request-support_guardians_btn-all">
                            <input
                              type="checkbox"
                              id="all-members"
                              name="all-members"
                              checked={allGuardiansIsChecked ? "checked" : ""}
                              onChange={e =>
                                this.allGuardiansToggle(e.target.checked)
                              }
                            />

                            <label htmlFor="all-members">
                              <div className="form_checkbox_text">
                                Notify all support team members
                              </div>
                            </label>
                          </div>

                          <div className="request-support_guardians_list">
                            {filteredGuardians.map(
                              ({ id, first_name, last_name }) => {
                                let active

                                selectedGuardians.map(item => {
                                  if (item === "all" || item.id === id) {
                                    active = true
                                  }

                                  return null
                                })

                                return (
                                  <button
                                    key={`support-team-members-${id}`}
                                    className={`request-support_guardians_item ${
                                      active
                                        ? "request-support_guardians_item--active"
                                        : ""
                                    }`}
                                    type="button"
                                    onClick={() => {
                                      this.onToggleMembers(id)
                                    }}
                                  >
                                    {first_name} {last_name}
                                  </button>
                                )
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="request-support_section_item">
                      <label
                        htmlFor="help-message"
                        className="request-support_section_label"
                      >
                        Request support from your team who will make suggestions
                        to improve your pre-plan.
                      </label>

                      <TextArea
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={formParticipant.helpMessage}
                      />
                    </div>

                    <Button
                      button={{
                        type: "button",
                        disabled: supportRequestsLoading
                      }}
                      onClick={this.handlSaveSupportRequest}
                      className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-sm"
                    >
                      Add request
                    </Button>
                  </Form>
                </div>
              </>
            )}

            {guardian && (
              <>
                <div className="request-support_title">Support suggestion</div>
                <div className="request-support_description">
                  Read your participant’s current response to the original
                  question (top), the support request (immediately above) and
                  make your suggestion to help improve the pre- plan (below).
                </div>

                <div className="request-support_section">
                  <div className="request-support_section_title">
                    Support message
                  </div>

                  <Form>
                    <div className="request-support_section_item">
                      <label
                        htmlFor="help-message"
                        className="request-support_section_label"
                      >
                        Suggestion title
                      </label>

                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={formGuardian.suggestionTitle}
                      />
                    </div>

                    <div className="request-support_section_item">
                      <label
                        htmlFor="help-message"
                        className="request-support_section_label"
                      >
                        What does your participant specifically need to improve?
                      </label>

                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={formGuardian.suggestionProblem}
                      />
                    </div>

                    <div className="request-support_section_item">
                      <label
                        htmlFor="help-message"
                        className="request-support_section_label"
                      >
                        What is your suggestion for improvement?
                      </label>

                      <TextArea
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={formGuardian.suggestionMessage}
                      />
                    </div>

                    <Button
                      button={{
                        type: "button",
                        disabled: supportRequestsLoading
                      }}
                      onClick={this.handlSaveSupportSuggestion}
                      className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-sm"
                    >
                      Add suggestion
                    </Button>
                  </Form>
                </div>
              </>
            )}

            <div className="request-support_section">
              <div className="request-support_section_title">
                Support requests &amp; suggestions
              </div>

              {!supportRequestsLoading ? (
                <Messages
                  onFilterChange={this.getFilteredSupportRequests}
                  filterValue={supportRequestsFilterValue}
                  messages={this.getSupportRequestMessages()}
                  messagesTitle="Recent activity"
                  filterOptions={filterOptions}
                  onToggleEndorsement={this.handleToggleEndorsement}
                  onArchiveSuggestions={this.handleArchiveSuggestions}
                  isParticipant={participant}
                />
              ) : (
                <Loader
                  type="TailSpin"
                  color="#0c4632"
                  height={80}
                  width={80}
                  className="loader"
                />
              )}
            </div>
          </>
        )}
      </div>
    )
  }
}

RequestSupport.defaultProps = {
  className: "",
  isHidden: true
}

RequestSupport.propTypes = {
  guardians: propTypes.arrayOf(propTypes.shape({})).isRequired,
  planSection: propTypes.string.isRequired,
  planSubsection: propTypes.oneOfType([propTypes.number, propTypes.string])
    .isRequired,
  className: propTypes.string,
  isHidden: propTypes.bool,
  onToggle: propTypes.func.isRequired,
  onFetchSupportRequests: propTypes.func.isRequired,
  onSaveSupportRequest: propTypes.func.isRequired,
  onToggleEndorsement: propTypes.func.isRequired,
  onArchiveSuggestions: propTypes.func.isRequired,
  location: propTypes.shape({
    state: propTypes.shape({
      planId: propTypes.string
    })
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    supportRequests: propTypes.shape({
      help_request: propTypes.shape({}),
      plan_section_entities: propTypes.shape({
        data: propTypes.arrayOf(propTypes.shape({}))
      }),
      plan_section: propTypes.string
    }),
    supportRequestsLoading: propTypes.bool,
    planId: propTypes.oneOfType([propTypes.string, propTypes.number])
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    supportRequests: PlansReducer.supportRequests,
    supportRequestsLoading: PlansReducer.supportRequestsLoading,
    planId: PlansReducer.id
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveSupportRequest: (token, message, type) =>
    dispatch(saveSupportRequest(token, message, type)),
  onFetchSupportRequests: (token, sectionCode, planId, filter) =>
    dispatch(fetchSupportRequests(token, sectionCode, planId, filter)),
  onToggleEndorsement: (token, suggestionId) =>
    dispatch(toggleEndorsement(token, suggestionId)),
  onArchiveSuggestions: (token, obj) => dispatch(archiveSuggestions(token, obj))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RequestSupport)
)
